/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Chip,
  IconButton,
  Link as LinkMui,
  Menu,
  MenuItem,
  Pagination,
  Stack,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { get, isEmpty, map, toString, find } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";

import { Alert, Notification, Question } from '../../../components/form';
import Table from "../../../components/form/TableFilter";

import Layout from "../../../components/layout/Layout";
import { PageSize, countPage } from "../../../config/const";
import Toolbar from "./Toolbar";

import { getClientsRoute } from "../../../store/transactions/thunk/clientsRoutes/getAll";
import { getInvoice } from "../../../store/transactions/thunk/invoice/getAll";
import { deleteInvoice } from "../../../store/transactions/thunk/invoice/delete";

const Invoices = () => {
  const [__] = useTranslation("invoice");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
  const [openQuestion, setOpenQuestion] = useState(false);

  const invoice = useSelector(state => state.transactions.invoice);
  const put = useSelector(state => state.transactions.invoice.put);
  const delet = useSelector(state => state.transactions.invoice.delete);

  const invoiceStatus = __(`invoiceStatus`, { returnObjects: true });

  const getData = ({ page, filters = filter}) => {
    dispatch(getInvoice({page, ...filters, Export: false }))
  }

  const getDataClients = () => {
    dispatch(getClientsRoute({ Export: true }));
  }

  const reload = () => getData({ page: 1 })
  
  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1})
    getDataClients();
  }, []);

  const debounceRef = useRef(null);

  const onFilterChange = (key, value) => {
    const updatedFilters = { ...filter, [key]: value };
    setFilter(updatedFilters);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (value.length === 0) {
      getData({ page: 1, filters: updatedFilters });
    } else if (value.length >= 3) {
      debounceRef.current = setTimeout(() => {
        getData({ page: 1, filters: updatedFilters });
      }, 300);
    }
  };

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  const onDelete = () => {
    dispatch(deleteInvoice(Number(selected)))
    setSelected({})
  }
  const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(true)
    setSelected(row)
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { handleCloseMenu(); getData({ page: 1, filter }); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [put, delet])

  const headTable = [
    {
      key: "status",
      label: __(`table.cols.idInvoiceStatus`),
      align: "center"
    },
    {
      key: "odooSOname",
      label: __(`table.cols.odooSOname`),
      align: "center"
    },
    {
      key: "billingTranckingId",
      label: __(`table.cols.idInvoice`),
      align: "center"
    },
    {
      key: "creationDate",
      label: __(`table.cols.creationDate`),
      align: "center"
    },    
    {
      key: "customerName",
      label: __(`table.cols.idClient`),
      align: "left"
    },
    {
      key: "servicios",
      label: __(`table.cols.servicios`),
      align: "center"
    },    
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { width: 80, position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]

  const dataTable = map(get(invoice, "data.data", []), (row, i) => ({
    ...row,
    billingTranckingId: <LinkMui component={Link} to={toString(get(row, "billingTranckingId"))} >{get(row, "billingTranckingId")}</LinkMui>,
    status: <Chip label={get(find(invoiceStatus, ({ value }) => value === get(row, "statusId", 1)), "label")} sx={{ bgcolor: `${get(find(invoiceStatus, ({ value }) => value === get(row, "statusId", 1)), "color")}26`, color: get(find(invoiceStatus, ({ value }) => value === get(row, "statusId", 1)), "color") }} />,
    creationDate: new Date(get(row, "creationDate")).toISOString().split('T')[0], // Formatear fecha sin hora
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(invoice, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        propsTable={{ showFilterRow: true }}
        filters={filter}
        onFilterChange={onFilterChange}
        loading={get(invoice, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(invoice, "data.totalRecord", 1))}
          page={get(invoice, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(invoice, "isLoading", false)}
        />
      </Stack>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        {get(selected, "billingTranckingId") > 0 && <Link to={toString(get(selected, "billingTranckingId"))}><MenuItem >{__(`table.menu.edit`)}</MenuItem></Link>}

        {get(selected, 'status') == 'OPEN' && <MenuItem onClick={handleDelete(get(selected, "billingTranckingId"))} >{__(`table.menu.delete`)}</MenuItem>}
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />

      <Question
        title={__("alert.deleteOrder.title")}
        detail={__("alert.deleteOrder.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </Layout>
  )
}

export default Invoices;


